import { Field, Float, ObjectType } from 'type-graphql'

/**
 * Filter-scoped aggregate totals for an owner's AI usage ledger — the multi-field
 * counterpart of the order list's single-value net total, since usage tracks tokens,
 * credits, and markup separately. `totalMarkup` uses the same `billedCcy - rawCcy`
 * definition as `computeAiMarkup`, aggregated server-side so it stays accurate under
 * pagination.
 */
@ObjectType()
export class AiCreditTransactionTotals {
  /** Sum of `inputTokens + outputTokens` across the filtered records. */
  @Field(() => Float)
  totalTokens: number

  /** Sum of `credits` across the filtered records. */
  @Field(() => Float)
  totalCredits: number

  /** Sum of `billedCcy - rawCcy` across the filtered records. */
  @Field(() => Float)
  totalMarkup: number
}
